import React, { useEffect, useState } from "react";
import {
  Space,
  Button,
  Card,
  Input,
  Form,
  notification,
  Select,
} from "antd";
import { updateModuleAction } from "../../redux/actions/courseActions";
import { connect } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";
import { useHistory } from "react-router-dom";

const { REACT_APP_EDITOR_KEY: apiKey } = process.env;

const EditModule = ({ updateModuleAction, moduleState, match, location }) => {
  const history = useHistory();

  const [state, setState] = useState({
    key: "new",
  });
  const [moduleContent, setModuleContent] = useState("");
  const [name, setName]= useState("");
  const [disablePublish, setDisablePublish] = useState(true);
  const [moduleInfo, setModuleInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const courseName = match.params.courseName;

  const onTabChange = (key, type) => {
    console.log(key, type);
    setState({ [type]: key });
  };
  const handleEditorChange = (content, editor) => {
    setDisablePublish(false);
    setModuleContent(content);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log("...."+name,value)

    setName(value);
    setModuleInfo({
      ...moduleInfo,
      [name]: value,
    });
    setDisablePublish(false);
  };

  const handleSubmit = () => {
    setLoading(true);
    const payload = {
      ...moduleInfo,
      name:name,
      description: moduleContent,
      courseName,
      oldModuleName: location.data?.name,
    };
    // console.log("++++++++++"+payload.name)
    updateModuleAction(payload);
  };

  useEffect(() => {
    setName(location.data?.name);
    setModuleContent(location.data?.description);
    if (moduleState.updateModuleData) {
      setLoading(false);
      notification.success({ message: "Module updated successfully" });
      history.push(`/dashboard/courses/${courseName}/module-management`);
      
      setTimeout(() => {
        window.location.reload(); 
      }, 1000);
    }
    if (moduleState.updateModuleError) {
      setLoading(false);
      notification.error({
        message: moduleState.updateModuleError.error,
      });
    }
  }, [moduleState]);

  const tabList = [
    {
      key: "new",
      tab: "Create new",
    },
    {
      key: "preview",
      tab: "Preview",
    },
  ];
  const children = [];

  const contentList = {
    // Module content here
    new: (
      <div>
        <Form.Item
          name="name"
          label="Module name"
          rules={[
            { required: true, message: "Please provide the module name" },
          ]}
        >
          <Input
            size="large"
            name="name"
            placeholder="Module name"
            type="text"
            onChange={handleChange}
            // initialValue={location.data?.name}
          />
        </Form.Item>
        <Form.Item
          name="description"
          label="Module content"
          rules={[
            { required: true, message: "Please provide the module name" },
          ]}
        >
          <Editor
            apiKey={apiKey}
            initialValue={location.data?.description}
            init={{
              height: 500,
              menubar: true,
              plugins: [
                "aprint preview importcss searchreplace autolink autosave save directionality visualblocks visualchars fullscreen link template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons",
              ],
              toolbar:
                "undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media pageembed template link anchor codesample | a11ycheck ltr rtl | showcomments addcomment",
            }}
            onEditorChange={handleEditorChange}
          />
        </Form.Item>
        <Form.Item name="tags" label="Tags">
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Module tags"
            defaultValue={location.data?.tags}
            onChange={(value) => {
              setModuleInfo({
                ...moduleInfo,
                tags: value.toString(),
              });
            }}
          >
            {children}
          </Select>
        </Form.Item>

        <Form.Item name="resources" label="Resources">
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Module resources"
            onChange={(value) => {
              setModuleInfo({
                ...moduleInfo,
                resources: value.toString(),
              });
            }}
          >
            {children}
          </Select>
        </Form.Item>
      </div>
    ),

    // Module preview here
    preview: (
      <div>
        {/* {{__html:  moduleContent}} */}
        <div dangerouslySetInnerHTML={{ __html: moduleContent }} />
      </div>
    ),
  };
  const onFinish = () => {
    alert("Heloo");
  };

  return (
    <>
      <Space style={{ marginBottom: 16 }}>
        <h2>{courseName}</h2>
      </Space>
      <Card
        style={{ width: "100%" }}
        title="Edit module"
        extra={
          <Button
            type="primary"
            size="large"
            // className="container-100"
            disabled={disablePublish}
            htmlType="submit"
            loading={loading}
            onClick={handleSubmit}
          >
            Update &#38; publish
          </Button>
        }
        tabList={tabList}
        activeTabKey={state.key}
        onTabChange={(key) => {
          onTabChange(key, "key");
        }}
      >
        <Form
          layout="vertical"
          hideRequiredMark
          onFinish={onFinish}
          className="mb-4"
          initialValues={{ name: location.data?.name }}
        >
          {contentList[state.key]}
        </Form>
      </Card>
    </>
  );
};
const mapStateToProps = (state) => {
  return { moduleState: state.courses.updateModule };
};

export default connect(mapStateToProps, { updateModuleAction })(EditModule);
